// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import Translator from 'translator';

const trans = function (key, parameters = {}, domain = 'messages') {
  return Translator.trans(key, parameters, domain);
};

const transchoice = function (key, count, parameters = {}, domain = 'messages') {
  return Translator.transChoice(key, isNaN(parseInt(count, 10)) ? 0 : count, parameters, domain);
};

export {
  trans,
  transchoice
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/filters/translation.js